import { Container } from 'react-bootstrap';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { FEATURES } from './config/features';
import { HelmetProvider } from 'react-helmet-async';

import Home from './pages/public/Home';
import TermsScreen from './pages/public/TermsScreen';
import PrivacyScreen from './pages/public/PrivacyScreen';
import About from './pages/public/About';
import ForEmployees from './pages/public/ForEmployees';
import Contact from './pages/public/Contact';
import Pricing from './pages/public/Pricing';
import PricingRoute from './pages/public/PricingRoute';
import AdminInvoices from './pages/app/AdminInvoices';
import ApprenticeshipExam from './pages/public/ApprenticeshipExam';
import MasterExam from './pages/public/MasterExam.js';
import Login from './pages/public/Login';
import Register from './pages/public/Register';
import ForgotPassword from './pages/public/ForgotPassword';
import ResetPassword from './pages/public/ResetPassword';
import LoginIos from './pages/public/LoginIos';

import HomeScreen from './pages/app/HomeScreen';
import EmployerHome from './pages/app/EmployerHome';
import EmployerJobs from './pages/app/EmployerJobs';
import EmployerApplications from './pages/app/EmployerApplications';
import EmployerEmployees from './pages/app/EmployerEmployees';
import EmployerVacations from './pages/app/EmployerVacations';
import EmployerReports from './pages/app/EmployerReports';
import EmployerSettings from './pages/app/EmployerSettings';
import EmployerPricing from './pages/app/EmployerPricing';
import PaymentSuccess from './pages/app/PaymentSuccess';
import PaymentCanceled from './pages/app/PaymentCanceled';
import Vacations from './pages/app/Vacations';
import EmployerLinkRequests from './pages/app/EmployerLinkRequests';
import Employment from './pages/app/Employment';
import EmploymentAdd from './pages/app/EmploymentAdd';
import EmploymentDescription from './pages/app/EmploymentDescription';
import UserProfile from './pages/app/UserProfile';
import Salaries from './pages/app/Salaries';
import EmployerWorkerVacationRequests from './pages/app/EmployerWorkerVacationRequests';

import Rights from './pages/app/Rights';
import Changes from './pages/app/Changes';
import CvCareer from './pages/app/CvCareer';
import Communication from './pages/app/Communication';
import LaborLaw from './pages/app/rights/LaborLaw';
import WorkTime from './pages/app/rights/WorkTime';
import Holidays from './pages/app/rights/Holidays';
import CvEmploymentAdd from './pages/app/cv/CvEmploymentAdd';
import CvEmploymentDescription from './pages/app/cv/CvEmploymentDescription';
import CvEducationAdd from './pages/app/cv/CvEducationAdd';
import CvEducationDescription from './pages/app/cv/CvEducationDescription';
import CvGeneratorPersonalInfo from './pages/app/cv/CvGeneratorPersonalInfo';
import CvGeneratorExperience from './pages/app/cv/CvGeneratorExperience';
import CvGeneratorEducation from './pages/app/cv/CvGeneratorEducation';
import CvGeneratorLanguages from './pages/app/cv/CvGeneratorLanguages';
import CvGeneratorBonusInfo from './pages/app/cv/CvGeneratorBonusInfo';
import CvGeneratorSummary from './pages/app/cv/CvGeneratorSummary';
import CvProfessionalSummary from './pages/app/cv/CvProfessionalSummary';
import CvAchievements from './pages/app/cv/CvAchievements';
import CvCertificates from './pages/app/cv/CvCertificates';
import CvLinks from './pages/app/cv/CvLinks';
import CvAdditionalInfo from './pages/app/cv/CvAdditionalInfo';
import CvAssociations from './pages/app/cv/CvAssociations';
import CvCustom from './pages/app/cv/CvCustom';

import CoverLetter from './pages/app/cv/CoverLetter';
import InterviewGuide from './pages/app/cv/InterviewGuide';
import SaturdayWork from './pages/app/communication/SaturdayWork';
import Overtime from './pages/app/communication/Overtime';
import Salary from './pages/app/communication/Salary';
import SickLeave from './pages/app/communication/SickLeave';
import WorkAndSchool from './pages/app/communication/WorkAndSchool';
import Vacation from './pages/app/communication/Vacation';
import AskExpert from './pages/app/AskExpert';

// Nowe komponenty z folderu changes
import Internships from './pages/app/changes/Internships';
import Documents from './pages/app/changes/Documents';
import TerminationModes from './pages/app/changes/TerminationModes';
import NoticePeriods from './pages/app/changes/NoticePeriods.js';

import SideBar from './components/SideBar';
import EmployerSideBar from './components/EmployerSideBar';
import PublicHeader from './components/PublicHeader';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/CookieConsent';
import { useSelector } from 'react-redux';
import LinkRequests from './pages/app/LinkRequests';
import EmployerHelp from './pages/app/EmployerHelp';

export const routes = [
  // ============================================================================
  // PUBLIC ROUTES - dostępne dla wszystkich użytkowników
  // ============================================================================
  { path: '/', element: <Home />, showHeaderFooter: true, requiresPaidAccount: false, fullBleed: true },
  { path: '/terms', element: <TermsScreen />, showHeaderFooter: true, requiresPaidAccount: false },
  { path: '/privacy', element: <PrivacyScreen />, showHeaderFooter: true, requiresPaidAccount: false },
  { path: '/dla-pracownikow', element: <ForEmployees />, showHeaderFooter: true, requiresPaidAccount: false, fullBleed: true },
  { path: '/why-us', element: <Navigate to="/dla-pracownikow" replace />, showHeaderFooter: true, requiresPaidAccount: false },
  { path: '/about', element: <About />, showHeaderFooter: true, requiresPaidAccount: false, fullBleed: true },
  { path: '/contact', element: <Contact />, showHeaderFooter: true, requiresPaidAccount: false },
  // Egzaminy ukryte przez FEATURES.exams — kod zostaje
  { path: '/exam', element: FEATURES.exams ? <ApprenticeshipExam /> : <Navigate to="/" replace />, showHeaderFooter: true, requiresPaidAccount: false },
  { path: '/master-exam', element: FEATURES.exams ? <MasterExam /> : <Navigate to="/" replace />, showHeaderFooter: true, requiresPaidAccount: false },
  { path: '/pricing', element: <PricingRoute />, showHeaderFooter: true, requiresPaidAccount: false, fullBleed: true },
  // Panel admina (isAdmin) — sprawdzanie uprawnień w komponencie i w API
  { path: '/admin/faktury', element: <AdminInvoices />, showHeaderFooter: true, requiresPaidAccount: false, fullBleed: true },
  { path: '/login', element: <Login />, showHeaderFooter: true, requiresPaidAccount: false },
  { path: '/login-ios', element: <LoginIos />, showHeaderFooter: true, requiresPaidAccount: false },
  { path: '/register', element: <Register />, showHeaderFooter: true, requiresPaidAccount: false },
  { path: '/forgot-password', element: <ForgotPassword />, showHeaderFooter: true, requiresPaidAccount: false },
  { path: '/reset-password/:token', element: <ResetPassword />, showHeaderFooter: true, requiresPaidAccount: false },
  // Strony płatności są poza układem aplikacji — .app zamienia ich biały tekst (ciemny motyw) na kolory A1
  { path: '/payment/success', element: <div className="app"><PaymentSuccess /></div>, showHeaderFooter: false, requiresPaidAccount: false, isPaymentPage: true },
  { path: '/payment/canceled', element: <div className="app"><PaymentCanceled /></div>, showHeaderFooter: false, requiresPaidAccount: false, isPaymentPage: true },

  // ============================================================================
  // SHARED ROUTES - dostępne dla wszystkich zalogowanych użytkowników
  // ============================================================================
  { path: '/user-profile', element: <UserProfile />, showHeaderFooter: false, requiresPaidAccount: false },
  { path: '/employer-profile', element: <UserProfile />, showHeaderFooter: false, requiresPaidAccount: false },

  // ============================================================================
  // WORKER ROUTES - dostępne tylko dla pracowników
  // ============================================================================
  { path: '/app-pricing', element: <Pricing />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: 'worker' },

  // Worker - Urlopy (DARMOWE — dotyczy też adult_worker, usunięty duplikat)
  { path: '/vacations', element: <Vacations />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: ['worker', 'adult_worker'] },

  // Worker - Historia zatrudnienia (DARMOWE)
  { path: '/employment', element: <Employment />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: ['worker', 'adult_worker'] },
  { path: '/employment/form', element: <EmploymentAdd />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: ['worker', 'adult_worker'] },
  { path: '/employment/description', element: <EmploymentDescription />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: ['worker', 'adult_worker'] },

  // Worker - Prawa i obowiązki (PAKIET GŁÓWNY)
  { path: '/rights', element: <Rights />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/rights/laborlaw', element: <LaborLaw />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/rights/worktime', element: <WorkTime />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/rights/holidays', element: <Holidays />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },

  // Worker - Zmiany (PAKIET GŁÓWNY)
  { path: '/changes', element: <Changes />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/internships', element: <Internships />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/documents', element: <Documents />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/termination-modes', element: <TerminationModes />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/notice-periods', element: <NoticePeriods />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },

  // Worker - Wynagrodzenia (DARMOWE)
  { path: '/salaries', element: <Salaries />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: ['worker', 'adult_worker'] },

  // Worker - CV & start kariery (PAKIET GŁÓWNY)
  { path: '/cv-career', element: <CvCareer />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/personal-info', element: <CvGeneratorPersonalInfo />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/experience', element: <CvGeneratorExperience />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/experience/form', element: <CvEmploymentAdd />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/experience/description', element: <CvEmploymentDescription />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/education', element: <CvGeneratorEducation />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/education/form', element: <CvEducationAdd />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/education/description', element: <CvEducationDescription />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/languages', element: <CvGeneratorLanguages />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/bonus-info', element: <CvGeneratorBonusInfo />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/summary', element: <CvGeneratorSummary />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/professional-summary', element: <CvProfessionalSummary />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/achievements', element: <CvAchievements />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/associations', element: <CvAssociations />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/links', element: <CvLinks />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/additional-info', element: <CvAdditionalInfo />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/certificates', element: <CvCertificates />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cv-generator/section/custom', element: <CvCustom />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/cover-letter', element: <CoverLetter />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/cv-career/interview-guide', element: <InterviewGuide />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },

  // Worker - Komunikacja (PAKIET GŁÓWNY)
  { path: '/communication', element: <Communication />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/communication/saturday-work', element: <SaturdayWork />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/communication/overtime', element: <Overtime />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/communication/salary', element: <Salary />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/communication/sick-leave', element: <SickLeave />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/communication/work-and-school', element: <WorkAndSchool />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },
  { path: '/communication/vacation', element: <Vacation />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'main', requiredUserType: 'worker' },

  // Worker - Zapytaj eksperta (DODATEK OSOBNY — scope "expert")
  { path: '/ask-expert', element: <AskExpert />, showHeaderFooter: false, requiresPaidAccount: true, requiredScope: 'expert', requiredUserType: 'worker' },

  // ============================================================================
  // EMPLOYER ROUTES - dostępne tylko dla pracodawców (wymagają płatnego konta)
  // ============================================================================
  { path: '/employer-home', element: <EmployerHome />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: 'employer' },
  { path: '/employer-help', element: <EmployerHelp />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: 'employer' },
  { path: '/employer-app-pricing', element: <EmployerPricing />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: 'employer' },
  { path: '/employer-jobs', element: <EmployerJobs />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: 'employer' },
  { path: '/employer-applications', element: <EmployerApplications />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: 'employer' },
  { path: '/employer-employees', element: <EmployerEmployees />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: 'employer' },
  { path: '/employer-link-requests', element: <EmployerLinkRequests />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: 'employer' },
  { path: '/employer-worker-vacation-requests', element: <EmployerWorkerVacationRequests />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: 'employer' },
  { path: '/employer-vacations', element: <EmployerVacations />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: 'employer' },
  { path: '/employer-reports', element: <EmployerReports />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: 'employer' },
  { path: '/employer-settings', element: <EmployerSettings />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: 'employer' },

  // ============================================================================
  // ADULT WORKER ROUTES — dorosły pracownik, ograniczony zakres (na razie)
  // ============================================================================
  { path: '/home-screen', element: <HomeScreen />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: ['worker', 'adult_worker'] },
  { path: '/link-requests', element: <LinkRequests />, showHeaderFooter: false, requiresPaidAccount: false, requiredUserType: ['worker', 'adult_worker'] },
];

function App() {
  const userLogin = useSelector(state => state.userLogin);
  const { userInfo } = userLogin;
  const isEmployer = userInfo?.user_type === 'employer';

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {routes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                route.showHeaderFooter ? (
                  // Strony publiczne
                  <>
                    <PublicHeader />
                    <main className="pub">
                      {route.fullBleed ? route.element : <div className="pub-wrap py-5">{route.element}</div>}
                    </main>
                    <Footer />
                  </>
                ) : route.isPaymentPage ? (
                  // Strona payment success bez layoutu
                  route.element
                ) : (
                  <div className="d-flex app">
                    {isEmployer ? <EmployerSideBar /> : <SideBar />}
                    <main className="flex-grow-1">
                      <ProtectedRoute 
                        requiresPaidAccount={route.requiresPaidAccount}
                        requiredUserType={route.requiredUserType}
                        requiredScope={route.requiredScope || 'main'}
                      >
                        <Container className="py-3">{route.element}</Container>
                      </ProtectedRoute>
                    </main>
                  </div>
                )
              }
            />
          ))}
        </Routes>
        <CookieConsent />
      </Router>
    </HelmetProvider>
  );
}

export default App;